import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useT } from '@/lib/i18n';

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

// Campo de senha com botão de mostrar/ocultar.
export function PasswordInput(props: Props) {
  const t = useT();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input type={show ? 'text' : 'password'} className="pr-10" {...props} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-muted-foreground transition-colors hover:text-foreground"
        aria-label={show ? t('auth.hidePassword') : t('auth.showPassword')}
        tabIndex={-1}
      >
        {show ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
}
